import {
  GET_DEPARTMENTS_SUCCESS,
  GET_DEPARTMENTS_FAIL,
  ADD_DEPARTMENT_SUCCESS,
  ADD_DEPARTMENT_FAIL,
  UPDATE_DEPARTMENT_SUCCESS,
  UPDATE_DEPARTMENT_FAIL,
  DELETE_DEPARTMENT_SUCCESS,
  DELETE_DEPARTMENT_FAIL,
  SHOW_LOADING,
  HIDE_LOADING,
} from "./actionTypes"

const INIT_STATE = {
  departments: [],
  permissions: [],
  loading: false,
}

const departments = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_DEPARTMENTS_SUCCESS:
      console.log(action.payload)
      return {
        ...state,
        departments: action.payload[0],
        permissions: action.payload[1],
      }
    case GET_DEPARTMENTS_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    case ADD_DEPARTMENT_SUCCESS:
      return {
        ...state,
        departments: [...state.departments, action.payload],
        permissions: [...state.permissions, action.payload],
        success: { data: "success" },
      }
    case ADD_DEPARTMENT_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    case UPDATE_DEPARTMENT_SUCCESS:
      return {
        ...state,
        departments: state.departments.map(service =>
          service._id.toString() === action.payload._id.toString()
            ? { service, ...action.payload }
            : service
        ),
        permissions: state.permissions.map(service =>
          service._id.toString() === action.payload._id.toString()
            ? { service, ...action.payload }
            : service
        ),
        success: { data: "success" },
      }
    case UPDATE_DEPARTMENT_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    case DELETE_DEPARTMENT_SUCCESS:
      return {
        ...state,
        departments: state.departments.filter(
          service => service._id.toString() !== action.payload._id.toString()
        ),
        permissions: state.permissions.filter(
          service => service._id.toString() !== action.payload._id.toString()
        ),
      }
    case DELETE_DEPARTMENT_FAIL:
      return {
        ...state,
        error: action.payload,
      } 
    case SHOW_LOADING:
      return {
        ...state,
        loading: action.payload,
      }
    case HIDE_LOADING:
      return {
        ...state,
        loading: action.payload,
      }
    default:
      return state
  }
}

export default departments
